import axios from 'axios';

/**
 * Crypto prices response type
 */
export interface CryptoPrices {
  BTC?: number;
  ETH?: number;
  USDT?: number;
  USDC?: number;
}

/**
 * Fetch current cryptocurrency prices
 *
 * @param symbols - Optional array of symbols to fetch (defaults to all)
 * @returns Object with symbol keys and price values
 *
 * @example
 * const prices = await getCryptoPricesApi(['BTC', 'ETH']);
 * console.log(prices); // { BTC: 45000, ETH: 3000 }
 */
export const getCryptoPricesApi = async (
  symbols?: string[],
): Promise<CryptoPrices> => {
  const params = symbols ? `?symbols=${symbols.join(',')}` : '';
  const response = await axios.get<CryptoPrices>(`/api/crypto/prices${params}`);
  return response.data;
};
